import React from 'react';
import { MenuItem } from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SingleOption } from '../../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';

interface MultiSelectDropdownProps {
  title?: string;
  options: SingleOption[] | any;
  value: SingleOption | SingleOption[] | undefined; // Depending on whether it's multi-select or not
  getId?: (option: SingleOption) => string;
  getLabel?: (option: SingleOption) => string;
  onChange?: (newValue: SingleOption | SingleOption[] | undefined | any) => void;
  isMulti?: boolean;
  width?: string;
  rootCss?: React.CSSProperties;
  addNone?: boolean;
  addAll?: boolean;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  title = 'SELECT',
  options,
  value,
  getId = (option: SingleOption) => option.id,
  getLabel = (option: SingleOption) => option.name,
  onChange,
  isMulti,
  width = '200px',
  rootCss,
  addNone,
  addAll,
}) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
      },
    },
  };

  const [t] = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = (event.target.value as unknown) as SingleOption | SingleOption[];

    onChange?.(newValue);
  };

  return (
    <div style={rootCss}>
      <FormControl variant="standard" sx={{ m: 1, width: width }} size="small">
        <InputLabel id="">{t(title)}</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple={isMulti}
          // defaultValue={value || (addAll ? t('ALL') : undefined)}
          value={value || (addAll ? t('ALL') : undefined)}
          onChange={(e:any) => {handleChange(e)}}
          MenuProps={MenuProps}
        >
          {addNone ? <MenuItem value={undefined}>{t('DC_NONE')}</MenuItem> : <div></div>}
          {addAll ? <MenuItem value={t('ALL')}>{t('ALL')}</MenuItem> : <div></div>}
          {options.map((option:any) => (
            <MenuItem key={getId(option)} value={option}>
              {t(getLabel(option)) || t(option?.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectDropdown;
